import React, { Component } from 'react';
import Welcome from '../../components/Welcome/Welcome';
import LogViewer from '../../components/LogViewer/LogViewer';
import DriverStatus from '../../components/DriverStatus/DriverStatus';
import DeliveryProgress from '../../components/DeliveryProgress/DeliveryProgress';
import DeliveryLookup from '../../components/DeliveryLookup/DeliveryLookup';
import Blank from '../../hoc/Blank/Blank';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';

class Home extends Component {
   
    componentDidMount() {
        if (this.props.isAuthenticated) {
            if (this.props.userType == 'scout') {
                this.props.onFetchScoutOrders();
            }
            else {
                this.props.onGetScouts();
            }
           
        } 
        this.props.onGetMulchYear(); 
           
    };
    render () {
        if (this.props.userType == 'scout' || !this.props.isAuthenticated) {
        return ( 
            <Blank>
        <Welcome />
            </Blank>
        );
        }
        else  {
            return (
            <div>
                
                <div style={{"width" : "35%","display": "inline-table"}}>
                
                    <LogViewer />
                </div>
                <div style={{"width" : "65%","display": "inline-table"}}>
                    <DeliveryProgress />                    
                    <DriverStatus />
                    <DeliveryLookup />
                </div>
            </div>
            );
        }
    }
}

const mapStateToProps = state => {
    return {
      mulchYear: state.orders.mulchYear,    
      summary: state.orders.salesSummary,
      orders: state.orders.orders,
      loading: state.orders.loading,
      isAuthenticated: state.orders.token !== null,
      userType : state.orders.userType
    };
  };
  
const mapDispatchToProps = dispatch => {
    return {
      onGetScouts:() => dispatch(actions.getScouts()),
      onFetchOrders: () => dispatch(actions.fetchOrders()),
      onFetchScoutOrders: () => dispatch(actions.fetchScoutOrders()),
      onGetMulchYear: () => dispatch(actions.getMulchYear()),
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(Home);


// WEBPACK FOOTER //
// ./src/containers/Home/Home.js